import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Box from '@mui/material/Box';
import { styled as materialStyled } from '@mui/material/styles';
import GridViewBoldSvg from '../../../assets/img/grid-view-blue-bold.svg';
import GridViewLinearSvg from '../../../assets/img/grid-view-blue-linear.svg';
import LeftToRightListDashBoldSvg from '../../../assets/img/left-to-right-list-dash-blue-bold.svg';
import LeftToRightListDashLinearSvg from '../../../assets/img/left-to-right-list-dash-blue-linear.svg';
import { theme } from '../../../theme/theme';
import { ViewType } from '../../../utils/enums/view-type.enum';
import { RootState } from '../../../redux/store';
import { useAppSelector } from '../../../redux/hooks';

const StyledToggleButtonGroup = materialStyled(ToggleButtonGroup)(() => ({
  backgroundColor: theme.palette.secondary.light,
  padding: '4px',
  height: '32px',
  gap: '4px',
}));

const StyledToggleButton = materialStyled(ToggleButton)(() => ({
  border: 'none',
  width: '24px',
  borderRadius: '4px !important',
  '&.Mui-selected': { border: 'none', backgroundColor: theme.palette.shades.lightBlueColor },
  '&:hover': { '&.Mui-selected': { backgroundColor: theme.palette.shades.lightBlueColor } },
}));

interface ToggleButtonsProps {
  changeView: (_view: ViewType) => void;
}

export default function ToggleButtons({ changeView }: ToggleButtonsProps) {
  const viewStatus = useAppSelector((state: RootState) => state.gem.componentStatus.view);
  const [view, setView] = React.useState<ViewType | null>((viewStatus as ViewType) || ViewType.LIST);

  React.useEffect(() => {
    if (view) {
      changeView(view);
    }
  }, [view]);

  const handleView = (event: React.MouseEvent<HTMLElement>, newView: ViewType | null) => {
    if (newView) {
      setView(newView);
      changeView(newView);
    }
  };

  return (
    <StyledToggleButtonGroup value={view} exclusive onChange={handleView} aria-label="text alignment">
      <StyledToggleButton value="list" aria-label="left aligned" role="button">
        {view === ViewType.LIST ? (
          <Box component="img" src={LeftToRightListDashBoldSvg} />
        ) : (
          <Box component="img" src={LeftToRightListDashLinearSvg} />
        )}
      </StyledToggleButton>
      <StyledToggleButton value="grid" aria-label="centered" role="button">
        {view === ViewType.GRID ? (
          <Box component="img" src={GridViewBoldSvg} />
        ) : (
          <Box component="img" src={GridViewLinearSvg} />
        )}
      </StyledToggleButton>
    </StyledToggleButtonGroup>
  );
}
